<template>
<div>

  <div class="form-group form-group-default required">
    <label>{{ $t("models.user.password") }}</label>
    <div class="controls">
      <input v-model="internalPassword"
             v-validate="'required|min:8'"
             type="password"
             class="form-control"
             name="password"
             required=""
             autocomplete="new-password"
             id="password"
             aria-required="true"
             @input="$emit('input', { field: 'password', value: $event.target.value })">
    </div>
  </div>

  <transition name="slide-fade">
    <label v-show="errors.has('password')"
           id="password-error"
           class="error"
           for="password">
      {{ errors.first('password') }}
    </label>
  </transition>

  <div class="form-group form-group-default required">
    <label>{{ $t("models.user.confirm_password") }}</label>
    <div class="controls">
      <input v-model="internalPasswordConfirmation"
             v-validate="'required|confirmed:password'"
             type="password"
             class="form-control"
             name="password_confirmation"
             required=""
             id="password_confirmation"
             aria-required="true"
             @input="$emit('input', { field: 'password_confirmation', value: $event.target.value })">
    </div>
  </div>

  <transition name="slide-fade">
    <label v-show="errors.has('password_confirmation')"
           id="password_confirmation-error"
           class="error"
           for="password_confirmation">
      {{ errors.first('password_confirmation') }}
    </label>
  </transition>

</div>
</template>

<script>
  import InputText from './InputText'

  export default {
    name: 'PasswordWithConfirmation',
    components: { InputText },
    props: {
      password: { type: String },
      passwordConfirmation: { type: String },
    },
    inject: ['$validator'],
    data() {
      return {
        internalPassword: this.password,
        internalPasswordConfirmation: this.passwordConfirmation,
      }
    },
    watch: {
      password: function(value) {
        this.internalPassword = this.password
      },
      passwordConfirmation: function(value) {
        this.internalPasswordConfirmation = this.passwordConfirmation
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/users/form/PasswordWithConfirmation.vue